export function isNotNull<T>(input: T | null): input is T {
  return input !== null;
}
export function isNotNullable<T>(input: T | null | undefined): input is T {
  return input !== null && input !== undefined;
}
